import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, isRef as _isRef, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "content-wrapper__tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content-header" }
const _hoisted_5 = { class: "flex scroll-content" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "on-desktop" }, "Apply", -1)
const _hoisted_8 = { class: "flex-column-start" }
const _hoisted_9 = ["onMouseenter"]

import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useCommentsStore } from '@/stores/comments';
import { useBlockListsStore } from '@/stores/blocks';
import { useUiStore } from '@/stores/ui';
import { useConfirmModal } from '@/stores/confirm-modal';
import { useTitle, watchDebounced } from '@vueuse/core';
import TheHeader from '@/components/TheHeader.vue';
import EmptyBMs from '@/components/EmptyBMs.vue'
import Table from '@/components/Table.vue'
import BusinessesSelector from '@/components/BusinessesSelector.vue';
import VButton from '@/components/VButton.vue';
import VAuthInput from '@/components/VAuthInput.vue';
import VSocialSelect from '@/components/VSocialSelect.vue';
import SearchIcon from '@/components/icons/other/SearchIcon.vue';
import DeleteIcon from '@/components/icons/other/DeleteIcon.vue';
import VBlockListSelect from '@/components/VBlockListSelect.vue';
import VDatePicker from '@/components/VDatePicker.vue';
import VAssetName from '@/components/VAssetName.vue';
import BlockListChips from '@/components/BlockListChips.vue';
import { useTabs } from '@/utils/hooks/use-tabs';
import VSwitch from '@/components/VSwitch.vue';
import { facebookApi } from '@/api/facebook';
import { useTooltip } from '@/stores/dynamic-tooltip';
import VCheckbox from '@/components/VCheckbox.vue';
import VIsAiListSelect from '@/components/VIsAiListSelect.vue';
import EditIcon from '@/components/icons/actions/EditIcon.vue';
import AddIcon from '@/components/icons/other/AddIcon.vue';
import ConnectSocialDialog from '@/components/dialogs/ConnectSocialDialog.vue'
import { useDialogStore } from '@/stores/dialogs';


export default /*#__PURE__*/_defineComponent({
  __name: 'CommentsModeration',
  setup(__props) {

const commentsStore = useCommentsStore()
const blockListStore = useBlockListsStore()

const currentData = computed(() => {
  return commentsStore.comments
})

const searchValue = ref("")

const columns = {
  name: { title: "Asset", minWidth: 160},
  status: { 
    minWidth: 70, 
    get: (item: any) => isActive(item),
    filters: [
      { title: "Active", filter: (item: any) => isActive(item) },
      { title: "Disabled", filter: (item: any) => !isActive(item) },
      { title: "Inactive", filter: (item: any) => isInactive(item) },
      { title: "Error", filter: (item: any) => isError(item) },
    ]
   },
  is_ai_moderation_active: {
    title: "AI Moderation",
    minWidth: 100,
    get: (item: any) => item.is_ai_moderation_active,
    filters: [
      { title: "Active", filter: (item: any) => item.is_ai_moderation_active },
      { title: "Disable", filter: (item: any) => !item.is_ai_moderation_active },
    ]
  },
  is_ai_engagement_active: {
    title: "AI Engagement",
    minWidth: 100,
    get: (item: any) => item.is_ai_engagement_active,
    filters: [
      { title: "Active", filter: (item: any) => item.is_ai_engagement_active },
      { title: "Disable", filter: (item: any) => !item.is_ai_engagement_active },
    ]
  },
  comment_count: { title: "Comments", get: (item: any) => item.comment_count, fallback: "-", sort: true },
  comment_hide_count: { title: "Hidden", get: (item: any) => item.comment_hide_count, fallback: "-", sort: true },
  // comment_remove_count: { title: "Deleted", get: (item: any) => item.comment_remove_count, fallback: "-", sort: true },
  comment_replied_count: { title: "Replied", get: (item: any) => item.comment_replied_count, fallback: "-", sort: true },
  comment_modereted: { title: "Handled", get: (item: any) => item.comment_modereted, fallback: "-", sort: true },
  // blocks: { title: "Blocklist", minWidth: 105, get: (item: any) => item.blocks }
}

const selected = reactive(new Set())

onMounted(async () => {
  await blockListStore.requestAll()
  await commentsStore.requestComments()
})

const { currentTab, tabs } = useTabs([
  { id: "bm", name: "BMs", path: "bms" },
  { id: "pages", name: "Pages", path: "pages" },
  // { id: "ad_accounts", name: "Ad accounts", path: "ad-accounts" },
])

const socialValue = ref<string | null>(null)

const selectedBusiness = reactive<App.Assets>({})

watch(currentTab, (value) => {
  commentsStore.params.groupby_id = [ "bm", "pages", "ad_accounts" ].indexOf(value)+1
}, { immediate: true })

watchDebounced(selectedBusiness, async (selected) => {
  const _values = { 
    filter_business_ids: selected.businesses || [], 
    filter_page_ids: selected.pages || [], 
    filter_ad_account_ids: selected.ad_accounts || [] 
  }
    
  for (let [_key, value] of Object.entries(_values)) {
    const key = _key as "filter_business_ids" | "filter_page_ids" | "filter_ad_account_ids"
    if (value.length > 0) {
      commentsStore.params[key] = value as string[]
    } else {
      commentsStore.params[key] = undefined
    }
  }
}, { debounce: 400 })

const toPercent = (num: number | undefined) => {
  if (typeof num !== "number") return undefined
  return Math.trunc(num) + "%"
}

const isActive = (item: any) => {
  return item.status_id === 1
}

const isInactive = (item: any) => {
  return item.status_id === 2
}

const isError = (item: any) => {
  return item.status_id === 3
}

const uiStore = useUiStore()
/*watch([ () => uiStore.period, () => currentTab.value, () => uiStore.customDate ], async ([ period, tab ], [ oldPeriod ]) => {
  await commentsStore.requestComments(tab, true)
}, { immediate: true })*/
watch(() => commentsStore.queryParams, async () => {
  await commentsStore.requestComments()
})

const confirmModal = useConfirmModal()
const deleteItems = (e: MouseEvent) => {
  confirmModal.open(e, "Are you sure you want to remove all Blocklists?", async () => {
    await commentsStore.removeBlockListFromItems(Array.from(selected.values()))
    selected.clear()
  })
}

const updateAIModerationActive = async (value: boolean, item: any, e: MouseEvent) => {
  if (value === false) {
    // When disabling, confirm with the user
    confirmModal.open(e, `Are you sure you want to disable AI Moderation for ${item.name}?`, async () => {
      // Make API call to disable AI Moderation
      if (currentTab.value === "pages") {
        await facebookApi.pages_ai_moderation_disable([{ id: item.id }]);
      }else{
        await facebookApi.bms_ai_moderation_disable([{ id: item.id }]);
      }
      item.is_ai_moderation_active = false;
    });
  } else {
    // When enabling, proceed directly
    item.is_ai_moderation_active = true;
    // Make API call to enable AI Moderation
    if (currentTab.value === "pages") {
      await facebookApi.pages_ai_moderation_enable([{ id: item.id }]);
    }else{
      await facebookApi.bms_ai_moderation_enable([{ id: item.id }]);
    }
  }
};

const updateAIEngagementActive = async (value: boolean, item: any, e: MouseEvent) => {
  if (value === false) {
    // When disabling, confirm with the user
    confirmModal.open(e, `Are you sure you want to disable AI Engagement for ${item.name}?`, async () => {
      // Make API call to disable AI engagement
      if (currentTab.value === "pages") {
        await facebookApi.pages_ai_engagement_disable([{ id: item.id }]);
      }else{
        await facebookApi.bms_ai_engagement_disable([{ id: item.id }]);
      }
      item.is_ai_engagement_active = false;
    });
  } else {
    // When enabling, proceed directly
    item.is_ai_engagement_active = true;
    // Make API call to enable AI engagement
    if (currentTab.value === "pages") {
      await facebookApi.pages_ai_engagement_enable([{ id: item.id }]);
    }else{
      await facebookApi.bms_ai_engagement_enable([{ id: item.id }]);
    }
  }
};

const selectedActions = ref<string[]>([])

const applyActions = async (e: MouseEvent) => {
  const items = Array.from(selected.values()) as {
    id: number,
    name: string,
    is_ai_moderation_active: boolean,
    is_ai_engagement_active: boolean
  }[]

  if (items.length === 0 || selectedActions.value.length === 0) return

  const confirmModal = useConfirmModal()

  confirmModal.open(e, "Apply selected actions to all selected assets?", async () => {
    for (let action of selectedActions.value) {
      const payload = items.map(item => ({ id: item.id }))

      if (action === 'activate_ai_moderation') {
        if (currentTab.value === "pages") {
          await facebookApi.pages_ai_moderation_enable(payload)
        } else {
          await facebookApi.bms_ai_moderation_enable(payload)
        }
        items.forEach(i => i.is_ai_moderation_active = true)
      }

      if (action === 'disable_ai_moderation') {
        if (currentTab.value === "pages") {
          await facebookApi.pages_ai_moderation_disable(payload)
        } else {
          await facebookApi.bms_ai_moderation_disable(payload)
        }
        items.forEach(i => i.is_ai_moderation_active = false)
      }

      if (action === 'activate_ai_engagement') {
        if (currentTab.value === "pages") {
          await facebookApi.pages_ai_engagement_enable(payload)
        } else {
          await facebookApi.bms_ai_engagement_enable(payload)
        }
        items.forEach(i => i.is_ai_engagement_active = true)
      }

      if (action === 'disable_ai_engagement') {
        if (currentTab.value === "pages") {
          await facebookApi.pages_ai_engagement_disable(payload)
        } else {
          await facebookApi.bms_ai_engagement_disable(payload)
        }
        items.forEach(i => i.is_ai_engagement_active = false)
      }
    }

    selected.clear()
    selectedActions.value = []
  })
}

const dialog = useDialogStore()

const connectSocial = () => {
  dialog.open(ConnectSocialDialog)
}

useTitle("Moderation | Reply200")

const tooltip = useTooltip()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeader, { title: "Dashboard" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            class: _normalizeClass({ active: _unref(currentTab) === tab.id }),
            onClick: ($event: any) => (currentTab.value = tab.id)
          }, _toDisplayString(tab.name), 11, _hoisted_3))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(VButton, {
            class: "mr-2 wb",
            onClick: connectSocial
          }, {
            default: _withCtx(() => [
              _createVNode(AddIcon, { class: "mr-0" })
            ]),
            _: 1
          }),
          _createVNode(VSocialSelect, {
            modelValue: socialValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((socialValue).value = $event)),
            class: "mr-2"
          }, null, 8, ["modelValue"]),
          _createVNode(BusinessesSelector, {
            modelValue: selectedBusiness,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedBusiness) ? (selectedBusiness).value = $event : null)),
            small: "",
            showInstagrams: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(VAuthInput, {
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchValue).value = $event)),
            icon: SearchIcon,
            placeholder: "Search",
            class: "light search",
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(VDatePicker)
        ])
      ]),
      _createVNode(Table, {
        modelValue: selected,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
        columns: columns,
        data: _unref(currentData),
        "row-key": "id",
        checkable: "",
        search: searchValue.value,
        "social-filter": socialValue.value,
        "default-sort": "comment_count",
        loading: !_unref(commentsStore).loaded,
        "hide-stub": _unref(uiStore).showBM
      }, {
        "alt-header": _withCtx(() => [
          _createVNode(VIsAiListSelect, {
            selected: Array.from(selected.values()),
            modelValue: selectedActions.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedActions).value = $event))
          }, null, 8, ["selected", "modelValue"]),
          _createVNode(VButton, {
            secondary: "",
            density: "",
            class: "ml-2",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (applyActions($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(EditIcon),
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        name: _withCtx(({ item, cell }) => [
          _createVNode(VAssetName, { item: item }, null, 8, ["item"])
        ]),
        blocks: _withCtx(({ item, cell }) => [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(VBlockListSelect, {
              selected: [ item ],
              small: ""
            }, null, 8, ["selected"]),
            _createVNode(BlockListChips, {
              item: item,
              "show-items": _unref(currentTab) === 'bm'
            }, null, 8, ["item", "show-items"])
          ])
        ]),
        comment_count: _withCtx(({ cell, item }) => [
          _createTextVNode(_toDisplayString(cell) + " ", 1),
          (item.comment_growth_percentage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["comments-moderation__grow-value", { negative: item.comment_growth_percentage < 0 }])
              }, _toDisplayString(item.comment_growth_percentage < 0? '↓': '↑') + _toDisplayString(Math.abs(item.comment_growth_percentage)) + "% ", 3))
            : _createCommentVNode("", true)
        ]),
        status: _withCtx(({ cell, item }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["active-marker", { inactive: item.status_id === 2, error: item.status_id === 3, unpaid: item.status_id === 6}])
          }, null, 2),
          (item.status_message)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "pointer",
                onMouseenter: ($event: any) => (_unref(tooltip).showTooltip($event, item.status_message, 'top'))
              }, _toDisplayString(item.status.name), 41, _hoisted_9))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(item.status.name), 1)
              ], 64))
        ]),
        comment_modereted: _withCtx(({ cell }) => [
          _createTextVNode(_toDisplayString(typeof cell === "number"? toPercent(cell): cell), 1)
        ]),
        is_ai_moderation_active: _withCtx(({ item }) => [
          _createVNode(VSwitch, {
            "model-parent-value": item.is_pages_ai_moderation_active,
            "model-business-value": item.is_business_ai_moderation_active,
            "model-unpaid-value": item.status_id === 6,
            "model-value": item.is_ai_moderation_active,
            "onUpdate:modelValue": (newValue, e) => updateAIModerationActive(newValue, item, e)
          }, null, 8, ["model-parent-value", "model-business-value", "model-unpaid-value", "model-value", "onUpdate:modelValue"])
        ]),
        is_ai_engagement_active: _withCtx(({ item }) => [
          _createVNode(VSwitch, {
            "model-parent-value": item.is_pages_ai_engagement_active,
            "model-business-value": item.is_business_ai_engagement_active,
            "model-unpaid-value": item.status_id === 6,
            "model-value": item.is_ai_engagement_active,
            "onUpdate:modelValue": (newValue, e) => updateAIEngagementActive(newValue, item, e)
          }, null, 8, ["model-parent-value", "model-business-value", "model-unpaid-value", "model-value", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "data", "search", "social-filter", "loading", "hide-stub"]),
      _createVNode(EmptyBMs)
    ])
  ], 64))
}
}

})